export enum NotificationType {
    Success = 10,
    Warning = 20,
    Info = 30,
    Danger = 40
}